
import React, { useEffect, useContext } from 'react'
import { useState } from 'react'
import { NavLink } from 'react-router-dom'
import "./Projects.css"
import UserContext from '../context/UserContext'
import { fetchStories, addStory, removeStory } from '../helpers/StoryFunctions'

const BASE_URL = process.env.REACT_APP_API_URL

export default function Projects() {

    const { isAuthenticated, logout } = useContext(UserContext)

    const [stories, setStories] = useState([])
    const [newStoryHeader, setNewStoryHeader] = useState("")
    const [newStoryContent, setNewStoryContent] = useState("")
    const [newStoryImages, setNewStoryImages] = useState([])

    useEffect(() => {
        fetchStories()
    }, [])

    const fetchStories = async () => {
        try {
            const response = await fetch(BASE_URL + "/stories/getAllStories")
            const data = await response.json()
            setStories(data)
        } catch (error) {
            console.log(error)
        }
    }

    const handleAddStory = async () => {

        if (newStoryHeader.trim() === "" || newStoryContent.trim() === "") {
            return
        }

        try {

            const data = await addStory(newStoryHeader, newStoryContent, newStoryImages)

            setNewStoryHeader("")
            setNewStoryContent("")
            setNewStoryImages([])

            fetchStories()

        } catch (error) {
            console.log(error)
        }
    }

    const handleRemoveStory = async (id, header) => {
        const isConfirmed = window.confirm(`Haluatko poistaa tarinan ${header} ?`)
        if (isConfirmed) {
            try {
                const result = await removeStory(id, header)
                if (result.status === "ok") {
                    alert("Story deleted")
                } else {
                    alert("Error removing story: " + result.error)
                }
            } catch (error) {
                console.error(error)
            } finally {
                fetchStories()
            }
        }
    }

    const handleImageChange = (e) => {
        const files = Array.from(e.target.files)
        setNewStoryImages(files)
    }

    return (
        <div>
            <h1 className='headerText'>Projektit</h1>

            {stories.length > 0 && (stories.map((item) => (
                <>
                    <NavLink className="storyLink " to={"/singleproject/" + item.id} >
                        <div className="storyContainer" key={item.id}>
                            <h3>{item.header}</h3>

                        </div>
                    </NavLink>
                    {isAuthenticated && <button onClick={() => handleRemoveStory(item.id, item.header)}>Delete</button>}
                </>
            )
            ))
            }
            <br></br>
            <hr></hr>
            <br></br>


            {isAuthenticated &&
                <div className='adminContainer'>
                    <label>Tarinan otsikko
                        <textarea
                            name='storyHeader'
                            className='projectsTextarea'
                            value={newStoryHeader}
                            onChange={e => setNewStoryHeader(e.target.value)}
                        />

                    </label>
                    <label> Tarina
                        <textarea
                            name='storyContent'
                            className='projectsTextarea'
                            value={newStoryContent}
                            onChange={e => setNewStoryContent(e.target.value)}
                        />
                    </label>

                    <label>Kuva
                        <input type="file" multiple onChange={handleImageChange} />
                    </label>

                    <button onClick={handleAddStory}>Add to stories</button>
                </div>}

        </div>
    )
}
